import { PropsWithChildren } from 'react';
import { FinalStepLayout } from '../features/layout/FinalStepLayout';
import { DefaultLayout } from '../features/layout/DefaultLayout';
import {
    WorkflowLayouts,
    WorkflowLayoutsStore,
    ReviewingFooterStore,
} from '@servicetitan/financing-application-workflow-shared';

const workflowLayouts: WorkflowLayouts = {
    DefaultLayout,
    FinalStepLayout,
};

export const WorkflowLayoutsProvider = ({ children }: PropsWithChildren) => {
    return (
        <ReviewingFooterStore.Provider>
            <WorkflowLayoutsStore.Provider initialState={workflowLayouts}>
                {children}
            </WorkflowLayoutsStore.Provider>
        </ReviewingFooterStore.Provider>
    );
};
